import { graphql } from '../../gql';

export const TALENT_DISCOVERY_DATA_V3 = graphql(`
  query TalentDiscoveryDataV3($query: TalentDiscoveryReqV3) {
    talent_discovery_search_v3(query: $query) {
      columns
      users {
        RCID
        current_company
        current_title
        education
        email
        employment_relationship
        end_date
        ethnicity
        first_name
        flight_risk
        gender
        graduation_year
        highest_degree
        last_name
        latitude
        linkedin_url
        location
        longitude
        original_user_id
        personal_email
        phone_number
        prestige
        remote_suitability
        salary_base
        salary_total
        shard
        skills
        start_date
        user_id
        user_location
        work_schedule
        work_history {
          RCID
          current_company
          current_title
          email
          end_date
          ethnicity
          first_name
          flight_risk
          gender
          highest_degree
          last_name
          latitude
          linkedin_url
          location
          longitude
          personal_email
          phone_number
          prestige
          remote_suitability
          salary_base
          salary_total
          start_date
          years_of_experience
        }
        education_history {
          rsid
          start_date
          end_date
          title
          university_name
        }
        years_of_experience
      }
      map_data {
        id
        type
        map_data_kind
        count
        share
        lat
        lon
        location
      }
      pagination {
        tot_pages_num
        tot_users_num
      }
    }
  }
`);

export const TALENT_DISCOVERY_MAP_DATA_V3 = graphql(`
  query TalentDiscoveryMapDataV3($query: TalentDiscoveryReqV3) {
    talent_discovery_search_v3(query: $query) {
      columns
      map_data {
        id
        type
        map_data_kind
        count
        share
        lat
        lon
        location
      }
    }
  }
`);
